// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__22QFS","buttonContainer":"style_buttonContainer__3fzpf","selected":"style_selected__2JmKm","tabsContent":"style_tabsContent__DAjNI"};